/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateInstrumentLinksFromFranklin} from '../api'

export const useMutationUpdateInstrumentLinksFromFranklin = createReactQueryMutationHook('updateInstrumentLinksFromFranklin', updateInstrumentLinksFromFranklin)
